/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Project } from './project';


/**
 * VPC component information
 */
export interface VpcComponentInfo { 
    /**
     * VPC Path
     */
    path?: string;
    project?: Project;
    /**
     * Associated site identifier
     */
    siteId?: string;
    /**
     * Associated vCenter identifier
     */
    vcenterId?: string;
}

